import { FC } from "react";
import "./PageNotFound.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../components/Button/Button";
import { RoutesRouter } from "../../models/Routes";

interface IPageNotFound {
  valuePageBack?: -1 | -2;
}

const PageNotFound2: FC<IPageNotFound> = ({ valuePageBack = -1 }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="container-page-not-found">
      <div className="wrapper-page">
        <div className="not-found-page">
          <div className="left__section">
            <div>
              <h2 className="title-not-found-page">404</h2>
            </div>
            <div className="line"></div>
            <div className="description">{t("pageNotFound.description")}</div>
            <div>
              <div>
                <Button onClick={() => navigate(RoutesRouter.companies)}>
                  {t("pageNotFound.labelButton")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound2;
